const BankDetailsTabs = ({
  activeTab,
  handleTabChangeFn,
}: {
  activeTab: string;
  handleTabChangeFn: (inputValue: string) => void;
}) => {
  return (
    <div className={`mt-8 mb-8 relative w-input`}>
      <div className={`flex gap-4 text-Caption1`}>
        <button
          className={`focus:outline-none ${activeTab === 'ACH' ? 'border-b-[2px] border-accent ' : ''} pb-2`}
          onClick={() => handleTabChangeFn('ACH')}>
          ACH
        </button>
        <button
          className={`focus:outline-none ${activeTab === 'SWIFT' ? 'border-b-[2px] border-accent ' : ''} pb-2`}
          onClick={() => handleTabChangeFn('SWIFT')}>
          Swift
        </button>
      </div>
      <div className={`absolute bottom-0 left-0 right-0 h-0.5 bg-white/[0.5] `}></div>
    </div>
  );
};

export default BankDetailsTabs;
